import { atom } from 'recoil';

import { storage } from 'utils/storage';

const localStorageEffect =
  key =>
  ({ setSelf, onSet }) => {
    const savedValue = storage.get(key);
    if (savedValue != null) {
      setSelf(savedValue);
    }

    onSet((newValue, _, isReset) => {
      if (isReset) {
        storage.remove(key);
      } else {
        storage.set(key, newValue);
      }
    });
  };

export const ModeAtom = atom({
  key: 'mode',
  default: 'dark',
  effects: [localStorageEffect('mode')],
});
